import React from 'react';
import { Lightbulb, Check, X, ArrowRight } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function ReframeSection() {
  return <section className="w-full bg-gray-800 py-16 px-4" data-id="element-288">
      <div className="max-w-5xl mx-auto" data-id="element-289">
        <div className="flex items-center justify-center mb-10" data-id="element-290">
          <Lightbulb size={32} className="text-amber-500 mr-3" data-id="element-291" />
          <h2 className="text-3xl font-bold text-white" data-id="element-292">
            Identity Breakthrough
          </h2>
        </div>
        <div className="bg-gray-900 rounded-lg p-8 mb-12 border border-gray-700" data-id="element-293">
          <h3 className="text-2xl font-semibold text-gray-100 mb-6 text-center" data-id="element-294">
            What if you're not shy?
          </h3>
          <p className="text-xl text-gray-200 mb-6" data-id="element-295">
            What if no one ever showed you how to lead with structure? What if
            your silence isn't who you are… but just a symptom?
          </p>
          <p className="text-xl font-bold text-amber-400 mb-8 text-center" data-id="element-296">
            Stop waiting for permission. Start building real influence.
          </p>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-297">
            <div data-id="element-298">
              <h4 className="text-xl font-semibold text-amber-500 mb-4" data-id="element-299">
                What you DON'T need:
              </h4>
              <ul className="space-y-3" data-id="element-300">
                <li className="flex items-start" data-id="element-301">
                  <X size={22} className="text-amber-500 mr-2 mt-1 flex-shrink-0" data-id="element-302" />
                  <p className="text-lg text-gray-300" data-id="element-303">
                    To be born a natural leader
                  </p>
                </li>
                <li className="flex items-start" data-id="element-304">
                  <X size={22} className="text-amber-500 mr-2 mt-1 flex-shrink-0" data-id="element-305" />
                  <p className="text-lg text-gray-300" data-id="element-306">
                    To have a large following already
                  </p>
                </li>
                <li className="flex items-start" data-id="element-307">
                  <X size={22} className="text-amber-500 mr-2 mt-1 flex-shrink-0" data-id="element-308" />
                  <p className="text-lg text-gray-300" data-id="element-309">
                    Years of experience or connections
                  </p>
                </li>
              </ul>
            </div>
            <div data-id="element-310">
              <h4 className="text-xl font-semibold text-amber-400 mb-4" data-id="element-311">
                What you DO need:
              </h4>
              <ul className="space-y-3" data-id="element-312">
                <li className="flex items-start" data-id="element-313">
                  <Check size={22} className="text-amber-400 mr-2 mt-1 flex-shrink-0" data-id="element-314" />
                  <p className="text-lg text-gray-300" data-id="element-315">
                    A trained voice and message
                  </p>
                </li>
                <li className="flex items-start" data-id="element-316">
                  <Check size={22} className="text-amber-400 mr-2 mt-1 flex-shrink-0" data-id="element-317" />
                  <p className="text-lg text-gray-300" data-id="element-318">
                    Strategic principles that work
                  </p>
                </li>
                <li className="flex items-start" data-id="element-319">
                  <Check size={22} className="text-amber-400 mr-2 mt-1 flex-shrink-0" data-id="element-320" />
                  <p className="text-lg text-gray-300" data-id="element-321">
                    The courage to start now, not later
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-10 text-center" data-id="element-322">
            <p className="text-lg text-gray-300 mb-4" data-id="element-323">
              Ready to transform your influence with the power of structure?
            </p>
            <a href="https://ebooksociety.co/cart/51475293536537:1" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-lg inline-flex items-center transition shadow-md" data-id="element-324">
              Get The Charlie Kirk Method Today
              <ArrowRight size={18} className="ml-2" data-id="element-325" />
            </a>
            <div className="max-w-md mx-auto" data-id="element-326">
              <PaymentIcons data-id="element-327" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}